
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="{{ 'promotion.backToCampaigns' | translate }}"
                        (click)="locationBack()"></button>
              </div>
              <div class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
                <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex"
                         [readonly]="false"></p-steps>
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.chooseCampaign">
              <kv-promo-tab-choose-campaign
                [wizardCampaigns]="wizardCampaigns"
                (nextStep)="downloadConfigAndGoToHeadTab($event)"
                [disableChooseCampaign]="disableChooseCampaign"
                [selectedWizard]="selectedWizard">
              </kv-promo-tab-choose-campaign>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.head">
              <kv-promo-tab-head
                *ngIf="selectedWizard"
                [configs]="headConfigs"
                [addEditCampaign]="addEditCampaign"
                [selectedWizard]="selectedWizard"
                [campaignTypes]="campaignTypes"
                (saveHead)="saveHeadTab($event)">
              </kv-promo-tab-head>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.touchPoint">
              <kv-promo-tab-touch-point
                [touchPoints]="touchPoints"
                [addEditCampaign]="addEditCampaign">
              </kv-promo-tab-touch-point>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.detail">
              <kv-promo-tab-detail
                [addEditCampaign]="addEditCampaign"
                [configs]="detailsConfigs">
              </kv-promo-tab-detail>
            </div>
          </div>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/campaignDetail.component.ts.CampaignDetailComponent.html